<template>
  <div class="image-text">
    <slot name="text"></slot>
    <slot name="image"></slot>
  </div>
</template>

<script>
export default {
  name: "ImageTextTopCenter",
};
</script>

<style lang="scss" scoped>
.image-text {
  flex-direction: column;
  align-items: center;
  text-align: center;
}
</style>
